import { createReducer } from '../handlers'
import types from './types'

const initialState = {
  limits: {},
  includedFreePrice: {},
  version: '',
  identifier: '',
  companyPlan: '',
  label: ''
}

/**
 * Update current plan
 * @param {Object} action
 * @param {Object<initialState>} action.plan
 */
const update = (state, action) => {
  const { plan } = action

  if (!plan || !Object.keys(plan).length) return state

  const {
    limits, includedFreePrice,
    version, identifier, companyPlan, label
  } = plan

  return {
    limits, includedFreePrice, version,
    identifier, companyPlan,
    label
  }
}

export default createReducer(initialState, {
  [types.update]: update
})
